import React from 'react';
import styled from 'styled-components';

import { Icon } from './_base';

const GooglePlayRectangularBadgeSVG = styled(Icon).attrs({ viewBox: '0 0 135 40' })`
    width: 3.325em;
`;

function GooglePlayRectangularBadge(props) {
    return (
        <GooglePlayRectangularBadgeSVG
            data-test="icon-google-play-rectangular"
            {...props}
            xmlns="http://www.w3.org/2000/svg"
        >
            <defs>
                <linearGradient
                    id="a"
                    x1="91.488%"
                    x2="-38.352%"
                    y1="4.986%"
                    y2="71.919%"
                >
                    <stop
                        offset="0%"
                        stopColor="#00A0FF"
                    />
                    <stop
                        offset="1%"
                        stopColor="#00A1FF"
                    />
                    <stop
                        offset="26%"
                        stopColor="#00BEFF"
                    />
                    <stop
                        offset="51%"
                        stopColor="#00D2FF"
                    />
                    <stop
                        offset="76%"
                        stopColor="#00DFFF"
                    />
                    <stop
                        offset="100%"
                        stopColor="#00E3FF"
                    />
                </linearGradient>
                <linearGradient
                    id="b"
                    x1="107.874%"
                    x2="-130.217%"
                    y1="49.942%"
                    y2="49.942%"
                >
                    <stop
                        offset="0%"
                        stopColor="#FFE000"
                    />
                    <stop
                        offset="41%"
                        stopColor="#FFBD00"
                    />
                    <stop
                        offset="78%"
                        stopColor="#FFA500"
                    />
                    <stop
                        offset="100%"
                        stopColor="#FF9C00"
                    />
                </linearGradient>
                <linearGradient
                    id="c"
                    x1="86.219%"
                    x2="-50.15%"
                    y1="17.877%"
                    y2="194.703%"
                >
                    <stop
                        offset="0%"
                        stopColor="#FF3A44"
                    />
                    <stop
                        offset="100%"
                        stopColor="#C31162"
                    />
                </linearGradient>
                <linearGradient
                    id="d"
                    x1="-18.754%"
                    x2="42.121%"
                    y1="-54.052%"
                    y2="24.917%"
                >
                    <stop
                        offset="0%"
                        stopColor="#32A071"
                    />
                    <stop
                        offset="7%"
                        stopColor="#2DA771"
                    />
                    <stop
                        offset="48%"
                        stopColor="#15CF74"
                    />
                    <stop
                        offset="80%"
                        stopColor="#06E775"
                    />
                    <stop
                        offset="100%"
                        stopColor="#00F076"
                    />
                </linearGradient>
            </defs>
            <g
                fill="none"
                fillRule="nonzero"
            >
                <path
                    d="M0 0h133v40H0z"
                    fill="#000"
                />
                <path
                    d="M46.193 10.24a2.714 2.714 0 0 1-.748 2c-.572.596-1.37.92-2.195.89a3.131 3.131 0 0 1-3.127-3.135 3.131 3.131 0 0 1 4.354-2.885c.361.146.683.376.938.67l-.529.53a1.993 1.993 0 0 0-1.636-.71 2.403 2.403 0 0 0-1.208 4.469 2.39 2.39 0 0 0 2.884-.349c.307-.333.484-.766.499-1.22H43.25v-.72h2.903c.027.152.04.306.04.46zM50.762 7.74h-2.694v1.9h2.454v.72h-2.454v1.9h2.694V13H47.27V7h3.492zM54.033 13h-.768V7.74H51.59V7h4.16v.74h-1.677V13zM58.682 13V7h.768v6zM62.861 13h-.768V7.74h-1.676V7h4.11v.74h-1.676V13zM72.318 12.22a3.107 3.107 0 0 1-4.39 0 3.246 3.246 0 0 1 0-4.45 3.088 3.088 0 0 1 4.39 0 3.236 3.236 0 0 1 0 4.45zm-3.82-.5a2.3 2.3 0 0 0 3.251 0 2.565 2.565 0 0 0 0-3.44 2.3 2.3 0 0 0-3.252 0 2.565 2.565 0 0 0 0 3.44zM74.283 13V7h.937l2.913 4.67V7h.768v6h-.798l-3.042-4.89V13h-.768z"
                    fill="#FFF"
                    stroke="#FFF"
                    strokeWidth=".5"
                />
                <path
                    d="M66.861 21.75a4.245 4.245 0 0 0-4.22 4.263 4.245 4.245 0 0 0 4.247 4.237A4.245 4.245 0 0 0 71.12 26a4.195 4.195 0 0 0-1.231-3.03 4.174 4.174 0 0 0-3.029-1.22zm0 6.83a2.573 2.573 0 0 1-2.501-1.462 2.585 2.585 0 0 1 .437-2.869 2.57 2.57 0 0 1 2.824-.645A2.58 2.58 0 0 1 69.255 26a2.464 2.464 0 0 1-.654 1.796 2.451 2.451 0 0 1-1.74.784zm-9.286-6.83a4.245 4.245 0 0 0-4.22 4.263 4.245 4.245 0 0 0 4.246 4.237A4.245 4.245 0 0 0 61.834 26a4.195 4.195 0 0 0-1.234-3.034 4.174 4.174 0 0 0-3.035-1.216h.01zm0 6.83a2.573 2.573 0 0 1-2.502-1.462 2.585 2.585 0 0 1 .438-2.869 2.57 2.57 0 0 1 2.823-.645A2.58 2.58 0 0 1 59.969 26a2.464 2.464 0 0 1-.658 1.8 2.451 2.451 0 0 1-1.746.78h.01zm-11.053-5.53v1.8h4.31a3.774 3.774 0 0 1-.998 2.27 4.403 4.403 0 0 1-3.322 1.32 4.794 4.794 0 0 1-4.788-4.8c0-2.651 2.144-4.8 4.788-4.8a4.582 4.582 0 0 1 3.242 1.29l1.267-1.27a6.266 6.266 0 0 0-4.519-1.82 6.59 6.59 0 0 0-5.923 3.226 6.624 6.624 0 0 0 0 6.758 6.59 6.59 0 0 0 5.923 3.226 5.977 5.977 0 0 0 4.599-1.85 6.009 6.009 0 0 0 1.556-4.22 5.884 5.884 0 0 0-.1-1.13h-6.055.02zm45.197 1.4a3.991 3.991 0 0 0-3.63-2.71 3.985 3.985 0 0 0-2.914 1.259 4.006 4.006 0 0 0-1.077 2.991 4.166 4.166 0 0 0 1.204 3.022 4.144 4.144 0 0 0 3.006 1.228 4.217 4.217 0 0 0 3.53-1.88l-1.446-1a2.423 2.423 0 0 1-2.084 1.18 2.154 2.154 0 0 1-2.055-1.29l5.675-2.35-.209-.45zm-5.785 1.42c-.041-.625.17-1.24.587-1.706a2.322 2.322 0 0 1 1.627-.774 1.645 1.645 0 0 1 1.576.9l-3.79 1.58zM81.315 30h1.865V17.5h-1.865V30zm-3.052-7.3h-.07a2.99 2.99 0 0 0-2.234-1 4.255 4.255 0 0 0-4.044 4.255 4.255 4.255 0 0 0 4.044 4.255 2.89 2.89 0 0 0 2.234-1h.06v.61c0 1.63-.868 2.5-2.265 2.5a2.344 2.344 0 0 1-2.134-1.51l-1.626.68a4.04 4.04 0 0 0 3.76 2.51c2.185 0 3.99-1.29 3.99-4.43V22h-1.765v.69l.05.01zm-2.135 5.88A2.587 2.587 0 0 1 73.771 26a2.587 2.587 0 0 1 2.357-2.58 2.598 2.598 0 0 1 2.268 2.584 2.598 2.598 0 0 1-2.278 2.576h.01zm24.32-11.08h-4.46V30h1.866v-4.74h2.603a3.878 3.878 0 0 0 3.589-1.86 3.898 3.898 0 0 0-.005-4.05 3.877 3.877 0 0 0-3.594-1.85zm0 6h-2.604v-4.29h2.643c1.187 0 2.15.965 2.15 2.155s-.963 2.155-2.15 2.155l-.04-.02zm11.5-1.8a3.49 3.49 0 0 0-3.321 1.91l1.655.69a1.765 1.765 0 0 1 1.696-.92c.479-.056.96.083 1.334.386.376.302.614.744.661 1.224v.13a4.111 4.111 0 0 0-1.945-.48c-1.785 0-3.59 1-3.59 2.81.035.78.383 1.512.966 2.03.582.518 1.349.778 2.125.72a2.621 2.621 0 0 0 2.374-1.22h.06v1h1.796v-4.79c.02-2.19-1.636-3.46-3.76-3.46l-.05-.03zm-.23 6.85a1.297 1.297 0 0 1-1.455-1.06c0-1 1.057-1.33 1.995-1.33a3.305 3.305 0 0 1 1.695.42 2.257 2.257 0 0 1-2.184 2l-.05-.03zM122.323 22l-2.134 5.42h-.06L117.913 22h-1.995l3.322 7.58-1.895 4.21h1.945L124.397 22H122.322zm-16.768 8h1.866V17.5h-1.866V30z"
                    fill="#FFF"
                />
                <path
                    d="M1.547.873c-.325.391-.489.892-.459 1.4v22.12c-.03.509.134 1.01.46 1.4l.07.07 12.358-12.39v-.29L1.617.793l-.07.08z"
                    fill="url(#a)"
                    transform="translate(7.758 6.667)"
                />
                <path
                    d="M18.066 17.613l-4.12-4.13v-.29l4.12-4.13.09.05 4.877 2.78c1.397.79 1.397 2.09 0 2.89l-4.877 2.78-.09.05z"
                    fill="url(#b)"
                    transform="translate(7.758 6.667)"
                />
                <path
                    d="M18.186 17.553l-4.21-4.22-12.429 12.46a1.623 1.623 0 0 0 2.075.06l14.574-8.3"
                    fill="url(#c)"
                    transform="translate(7.758 6.667)"
                />
                <path
                    d="M18.186 9.113L3.612.813a1.623 1.623 0 0 0-2.075.06l12.44 12.46 4.209-4.22z"
                    fill="url(#d)"
                    transform="translate(7.758 6.667)"
                />
                <path
                    d="M25.824 24.13L11.34 32.38a1.662 1.662 0 0 1-1.995 0l-.07.07.07.07c.59.447 1.405.447 1.995 0l14.574-8.3-.09-.09z"
                    fill="#000"
                    opacity=".2"
                />
                <path
                    d="M9.306 32.32a2.003 2.003 0 0 1-.46-1.4v.15c-.03.508.134 1.009.46 1.4l.07-.07-.07-.08zM30.812 21.3l-4.988 2.83.09.09 4.878-2.78a1.75 1.75 0 0 0 .997-1.44 1.86 1.86 0 0 1-.977 1.3z"
                    fill="#000"
                    opacity=".12"
                />
                <path
                    d="M11.37 7.62L30.812 18.7c.515.255.883.735.997 1.3a1.75 1.75 0 0 0-.997-1.44L11.36 7.48c-1.396-.79-2.533-.13-2.533 1.47v.15c.04-1.61 1.157-2.27 2.543-1.48z"
                    fill="#FFF"
                    opacity=".25"
                />
            </g>
        </GooglePlayRectangularBadgeSVG>
    );
}

export {
    GooglePlayRectangularBadge as default,
    GooglePlayRectangularBadge,
};
